import React, { useMemo } from "react";
import get from "lodash/get";
import { Header } from "@tvg/design-system/web";
import tvgConf from "@tvg/conf";
import StoryblokClient from "storyblok-js-client";
import {
  PlaylistVideos,
  Articles,
  RacingFAQ,
  HomePageLoading,
  WalkthroughModal,
  SeoHeader
} from "../components";
import useHomeData from "../hooks/useHomeData";
import { getSectionByType } from "../utils/storyblok";
import {
  Container,
  Title,
  Columns,
  MainContent,
  SideContent,
  LatestVideos
} from "./styled-components";

const storyblokToken = tvgConf().config("storyblokToken");
const storyblokClient = new StoryblokClient({
  accessToken: storyblokToken,
  cache: {
    clear: "auto",
    type: "memory"
  }
});

export const Homepage = () => {
  const { homeData, isLoading } = useHomeData();

  const latestVideos = useMemo(
    () => getSectionByType(homeData?.sections, "video_playlist"),
    [homeData]
  );

  const faq = useMemo(
    () => getSectionByType(homeData?.sections, "faq"),
    [homeData]
  );

  if (isLoading) return <HomePageLoading />;

  return (
    <Container data-qa-label="education-hub-container">
      {homeData?.seo_meta_data && (
        <SeoHeader seoMetaData={homeData.seo_meta_data} />
      )}
      <Title>
        <Header
          tag="h1"
          fontFamily="bold"
          qaLabel="education-hub-title"
          color="--fd-colors-content-strong"
        >
          {get(homeData, "title", "")}
        </Header>
      </Title>
      {latestVideos && (
        <LatestVideos data-qa-label="section-latest-videos">
          <PlaylistVideos
            title={latestVideos.title}
            playlistUrl={get(latestVideos.content, "0.playlist_url")}
          />
        </LatestVideos>
      )}
      <Columns>
        <MainContent data-qa-label="education-hub-main-content">
          <Articles data={homeData?.sections ?? []} />
        </MainContent>
        <SideContent data-qa-label="education-hub-side-content">
          <RacingFAQ data={faq} storyblokClient={storyblokClient} />
        </SideContent>
      </Columns>
      <WalkthroughModal />
    </Container>
  );
};
